export const baseURL = process.env.REACT_APP_BASE_URL
export const apiURL = process.env.REACT_APP_API_URL
export const perPage = Number(process.env.REACT_APP_PER_PAGE) || 9

export const stripeKey = process.env.REACT_APP_STRIPE_KEY

export const infoEmail = process.env.REACT_APP_INFO_EMAIL
export const whatsAppPhoneNumber = process.env.REACT_APP_WA_PHONE_NUMBER